import React from 'react';
import { ICustomIconProps } from '../types';

const IconWorkflow: React.FC<ICustomIconProps> = ({ size = 20, color = 'currentColor', className = '' }) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
    <path d='M16.96 6.16992C18.96 7.55992 20.34 9.76992 20.62 12.3199' stroke={color} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M3.49023 12.3702C3.75023 9.83021 5.11023 7.62021 7.09023 6.22021' stroke={color} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    <path
      d='M8.18994 20.9399C9.34994 21.5299 10.6699 21.8599 12.0599 21.8599C13.3999 21.8599 14.6599 21.5599 15.7899 21.0099'
      stroke={color}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.0598 7.70014C13.5951 7.70014 14.8398 6.45549 14.8398 4.92014C14.8398 3.38479 13.5951 2.14014 12.0598 2.14014C10.5244 2.14014 9.27979 3.38479 9.27979 4.92014C9.27979 6.45549 10.5244 7.70014 12.0598 7.70014Z'
      stroke={color}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M4.8298 19.9199C6.36516 19.9199 7.60981 18.6752 7.60981 17.1399C7.60981 15.6045 6.36516 14.3599 4.8298 14.3599C3.29445 14.3599 2.0498 15.6045 2.0498 17.1399C2.0498 18.6752 3.29445 19.9199 4.8298 19.9199Z'
      stroke={color}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M19.1701 19.9199C20.7055 19.9199 21.9501 18.6752 21.9501 17.1399C21.9501 15.6045 20.7055 14.3599 19.1701 14.3599C17.6348 14.3599 16.3901 15.6045 16.3901 17.1399C16.3901 18.6752 17.6348 19.9199 19.1701 19.9199Z'
      stroke={color}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default IconWorkflow;
